import { render, staticRenderFns } from "./FootballPool.vue?vue&type=template&id=5f1a9a99&scoped=true"
import script from "./FootballPool.vue?vue&type=script&lang=js"
export * from "./FootballPool.vue?vue&type=script&lang=js"
import style0 from "./FootballPool.vue?vue&type=style&index=0&id=5f1a9a99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1a9a99",
  null
  
)

export default component.exports